<nz-layout>
    <nz-content>
        <!-- Header -->
        <div
            class="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10"
        >
            <button nz-button nzType="default" (click)="close()">Close</button>
            <h4 class="m-0">All Consultations</h4>
            <button nz-button nzType="primary" (click)="markAllAsReviewed()">
                <i class="fa-solid fa-check-double mr-2"></i>Mark All as
                Reviewed
            </button>
        </div>

        <!-- Profile: ID images -->
        <div class="p-4">
            <h5>Documents</h5>
            <div class="flex flex-wrap gap-3 items-start">
                <ng-container
                    *ngIf="idFiles.length > 0 || filesLoading; else noFiles"
                >
                    <nz-spin
                        *ngIf="filesLoading && idFiles.length === 0"
                        nzSimple
                    ></nz-spin>
                    <div
                        *ngFor="let file of idFiles"
                        class="text-center"
                    >
                        <nz-spin [nzSpinning]="!file.loaded">
                            <div
                                class="id-placeholder"
                                *ngIf="!file.buffer"
                            >
                                <i
                                    class="fa-solid fa-image text-gray-400 text-2xl"
                                ></i>
                            </div>
                            <img
                                *ngIf="file.buffer"
                                [src]="getImageSrc(file)"
                                (click)="openImage(file)"
                                class="cursor-pointer rounded border hover:border-blue-400"
                                style="
                                    max-height: 120px;
                                    max-width: 180px;
                                    object-fit: contain;
                                "
                                alt="{{ getIdFileLabel(file.name) }}"
                            />
                        </nz-spin>
                        <div class="text-xs mt-1 text-gray-500">
                            {{ getIdFileLabel(file.name) }}
                        </div>
                        <div *ngIf="getDrugCardTypeLabel(file)" class="text-xs text-gray-400 capitalize">
                            {{ getDrugCardTypeLabel(file) }}
                        </div>
                        <div *ngIf="getDrugCardRelationship(file)" class="text-xs text-gray-400 capitalize">
                            Relationship: {{ getDrugCardRelationship(file) }}
                        </div>
                        <div class="text-xs text-gray-400">
                            {{ (file.updatedAt || file.createdAt) | date: 'MMM d, yyyy' }}
                        </div>
                    </div>
                </ng-container>
                <ng-template #noFiles>
                    <span class="text-gray-400 text-sm"
                        >No ID documents on file</span
                    >
                </ng-template>
            </div>
        </div>

        <nz-divider class="mt-0"></nz-divider>

        <!-- Collapsible consultation sections -->
        <nz-collapse [nzBordered]="false">
            <nz-collapse-panel
                *ngFor="let item of qnrItems"
                [nzHeader]="item.req.label"
                [nzExtra]="statusTag"
                [nzActive]="false"
            >
                <ng-template #statusTag>
                    <nz-tag [nzColor]="getStatusColor(item.req.qnr.status)">{{
                        getStatusLabel(item.req.qnr.status)
                    }}</nz-tag>
                </ng-template>
                <consultation-viewer
                    [questions]="item.questions"
                    [data]="item.data"
                    [brand]="brandName"
                ></consultation-viewer>
            </nz-collapse-panel>
        </nz-collapse>

        <div
            *ngIf="qnrItems.length === 0"
            class="p-4 text-gray-400 text-center"
        >
            No consultations attached to requirements.
        </div>
    </nz-content>
</nz-layout>
